import { createAccPage } from "../../locales/en";

export const CategoryData = [
  {
    name: "Info",
    value: "Info"
  },
  {
    name: "Warning",
    value: "Warning"
  },
  {
    name: "Error",
    value: "Error"
  }
];

export const NotificationData = [
  {
    name: "Email",
    value: "Email"
  },
  {
    name: "In App",
    value: "In App"
  },
  {
    name: "Push",
    value: "Push"
  }
];

export const RecipientData = [
  {
    name: "User",
    value: "User"
  },
  {
    name: "Role",
    value: "Role"
  },
  {
    name: "Department",
    value: "Department"
  },
  {
    name: "All",
    value: "All"
  }
];

const YEARS = Array.from({ length: 49 }, (_, i) => `${2002 + i}`);

export const NotificationyearData = [
  { value: "", name: "-Select-" },
  ...YEARS.map((year) => ({
    value: year,
    name: year
  }))
];

export const NotificationMonthData = [
  { name: "January", value: "1" },
  { name: "February", value: "2" },
  { name: "March", value: "3" },
  { name: "April", value: "4" },
  { name: "May", value: "5" },
  { name: "June", value: "6" },
  { name: "July", value: "7" },
  { name: "August", value: "8" },
  { name: "September", value: "9" },
  { name: "October", value: "10" },
  { name: "November", value: "11" },
  { name: "December", value: "12" }
];

export const activeStatusOptions = [
  { value: true, label: createAccPage.active },
  { value: false, label: createAccPage.inactive }
];
